const CLICKABLE_CARDS = document.querySelectorAll('.js-clickable-card')
const CARD_LINK_SELECTOR = 'a.card__link'

if (CLICKABLE_CARDS.length > 0) {
  CLICKABLE_CARDS.forEach((card) => {
    const cardLink = card.querySelector(CARD_LINK_SELECTOR)
    card.addEventListener('click', () => cardLink.click())
  })
}